import { callApiToServer } from '../callApi';

export async function addAdvertisementAPI(
    authtoken,
    object
) {
    try {
        let header = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            "authorization": "Berear " + authtoken
        };

        let body = JSON.stringify(object);

        let endUrl = "v1/auth/edit-advertisement";

        let responseData = await callApiToServer(body, header, "POST", endUrl);

        return responseData;

    } catch (err) {
        throw err;
    }
}
